<template>
	<div class="border-b border-grey">
		<div class="container">
			<div class="z-30 flex py-6 lg:gap-12 text-blue justify-between">
				<button :disabled="disablePrev" class="flex gap-2 items-center flex-row-reverse disabled:opacity-50 disabled:pointer-events-none" @click="changeMonth(-1)">
					<span class="uppercase md:text-md">{{ prevLabel }}</span>
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
						<path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
					</svg>
				</button>
				<div v-if="showTitle" class="grow flex justify-center gap-2 items-center">
					<Dropdown 
						:label="currentLabel" 
						:model-value="props.modelValue" 
						@update:modelValue="emit('update:modelValue', $event)" 
						:options="options" />
				</div>
				<button class="flex gap-2 items-center disabled:opacity-50" @click="changeMonth(1)">
					<span class="uppercase md:text-md">{{ nextLabel }}</span>
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
						<path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
					</svg>
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed } from "vue";
import { parse, format, addMonths, startOfMonth } from "date-fns";
import Dropdown from '@facet/global/Dropdown.vue';

const props = defineProps({
	showTitle: {
		type: Boolean,
		default: true
	},
	modelValue: {
    	type: String, // format: "YYYY-MM"
    	required: true
  	}
});

const emit = defineEmits(["update:modelValue"])

// For next/prev months nav
const today = startOfMonth(new Date())
const lastMonth = addMonths(today, -1)

const currentDate = computed(() =>
  parse(props.modelValue, "yyyy-MM", new Date())
)

const currentLabel = computed(() =>
  format(currentDate.value, "MMMM yyyy")
)

const prevDate = computed(() => addMonths(currentDate.value, -1))
const prevLabel = computed(() => format(prevDate.value, "MMM"))

const nextDate = computed(() => addMonths(currentDate.value, 1))
const nextLabel = computed(() => format(nextDate.value, "MMM"))

function changeMonth(direction) {
  const newDate = addMonths(currentDate.value, direction)
  emit("update:modelValue", format(newDate, "yyyy-MM"))
}

const options = computed(() =>
  Array.from({ length: 12 }, (_, i) => {
    const d = addMonths(startOfMonth(new Date()), i)
    return {
      value: format(d, "yyyy-MM"),
      label: format(d, "MMMM yyyy")
    }
  })
)

const disablePrev = computed(() => {
  const prevKey = format(prevDate.value, "yyyy-MM")
  const lastKey = format(lastMonth, "yyyy-MM")
  return prevKey === lastKey
})

</script>